export const cfg = {
  name: 'page',
  mode: 'browser', //  'browser' || 'hash'  // 出于整个公司部署系统原因，我们现阶段只支持一个路由router。
}

export const ACCESS_TOKEN = 'access_token'
export const APP_SCHEME = 'cdfsunrise'
export const CLIENT_INVOKE_JS_FUNCNAME = 'sunriseCalljs'
export const LOCALSTORAGE_TOKENINFO = 'tokeninfo'
export const LOCALSTORAGE_USERINFO = 'userinfo'
export const CLASSNAME_PREFIXER = 'sr-cms'
export const ORIGIN_FROM = 'h5'
export const WX_MINI_CONFIG = 'operation_activity_config'
export const WX_BASE_CONFIG_LIST = 'operation_activity_config_list'

export enum MEMBER_TYPE {
  sunrise = '日上会员',
  cdf = '中免大会员',
  beijing = '北京跨境用户',
}

export default cfg
